<div class="page-container gap-24">
  <div class="page-title">Kooperationen</div>

  <div class="flex-c gap-12">
    <span class="align-self-stretch font-regular-body-large">
      Unsere Kooperationspartner sorgen nicht nur dafür, dass ihr Wissen
      kostengünstiger konsumieren könnt, sie bieten euch darüber hinaus weitere
      Annehmlichkeiten wie z.B. Rabatte oder Zusatzleistungen.
    </span>
  </div>

  @if (loading) {
    <div class="sponsor-cards-grid">
      @for (item of [1, 2, 3]; track item) {
        <p-skeleton borderRadius="12px" width="100%" height="140px" />
      }
    </div>
  } @else if (sponsorCards.length === 0) {
    <span class="font-regular-body-large">
      Aktuell sind keine Kooperationspartner verfügbar.
    </span>
  } @else {
    <div class="sponsor-cards-grid">
      @for (card of sponsorCards; track card.id) {
        <div
          class="sponsor-card sponsor-card-large"
          [class.cursor-pointer]="card.link"
          (click)="openLink(card)">
          @if (card.image) {
            <img [src]="card.image" alt="Bild" class="image" />
          } @else {
            <div class="image-placeholder">
              <i class="fa-regular fa-image"></i>
            </div>
          }
          <div class="text">
            <div class="title">
              {{ card.title ?? 'Titel' }}
            </div>
            <div class="description">
              {{ card.description ?? 'Hier steht die Beschreibung' }}
            </div>
          </div>
        </div>
      }
    </div>
  }

  <div class="flex-c gap-12 associations-section">
    <span class="align-self-stretch font-medium-headline-medium">
      Diese Verbände bieten ihren Mitgliedern Rabatte auf unser komplettes
      Kurs-Sortiment:
    </span>

    <div class="associations-grid">
      @for (
        association of associationPartners;
        track association.abbreviation
      ) {
        <div class="association-item">
          <img
            [src]="association.logo"
            [alt]="association.abbreviation + ' Logo'"
            class="association-logo"
            [class.association-logo-wide]="association.wideLogo"
            (error)="
              $any($event.target).src = 'assets/images/image-placeholder.svg'
            " />
          <div class="association-text">
            <span class="association-abbreviation">
              {{ association.abbreviation }}
            </span>
            <span class="association-name">{{ association.name }}</span>
          </div>
        </div>
      }
    </div>
  </div>
</div>
